//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/DxfdwgCreator.js";
let d=[[],[[["draftingSheet","unloadPart"],"ConvertSheetTo2dpart",{R_:{temp2dpartFilename:''}},2,0],[[],"CreateTemp2dpartsDir",{R_:{temp2dpartsDir:''}},0,0],[["outputDxfdwgFolder"],"SetOutputDxfdwgFolder",{},1,0]],[]];
SPLM.AME.DxfdwgExportBuilder = class extends SPLM.DxfdwgCreator{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.DxfdwgExportBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;